<!-- 商品主数据新增 -->
<template>
  <div class="goodsDetail">
    <!-- 按钮 -->
    <div class="btn" v-if="!fromFlag">
      <el-button
        v-hasPermi="['2021050815440366025']"
        type="primary"
        :disabled="
          goodsDetail.parentProductStatus == 'ZT01' ||
          goodsDetail.parentProductStatus == 'ZT02' ||
          goodsDetail.parentProductStatus == 'ZT04'
        "
        @click="modify"
        >{{ this.$t('goods.button.modify') }}</el-button
      >
      <!-- <el-button
        v-hasPermi="['2021050815442183832']"
        type="primary"
        class="fixed-bottom-btn"
        :loading="loading"
        v-if="goodsDetail ? goodsDetail.parentProductStatus == 'ZT03' : true"
        @click="syncMdg()"
        >{{ this.$t('goods.button.mdg') }}</el-button
      > -->
    </div>

    <div class="btns" v-if="fromFlag && userInfo.userInfo.adminFlag === 1">
      <el-button type="primary" @click="handleReject('1')" v-if="isApproval">批准</el-button>
      <el-button type="primary" @click="handleReject('0')" v-if="isReject">驳回</el-button>
    </div>

    <!-- tab页 -->
    <el-tabs class="addGoodsTabs" type="border-card">
      <!-- 物产化工主数据 -->
      <el-tab-pane :label="$t('goods.tab.wchgData')">
        <wchg-data
          ref="wchgData"
          :addFlag="false"
          :isEdit="false"
          :goodsDetail="goodsDetail"
          :extendList="extendList"
          v-if="goodsDetail"
          :dictList="dictList"
          @determineSubclassesRejected="determineSubclassesRejected"
          :addedTaxRateOptions="dictList.addedTaxRateOptions"
        />
      </el-tab-pane>
      <!-- 公司自有数据 -->
      <el-tab-pane :label="$t('goods.tab.companyData')">
        <company-data
          ref="companyData"
          :isEdit="falhistoryDatase"
          :extendList="extendList"
          :goodsDetail="goodsDetail"
          :dictList="dictList"
          :firstTabData="firstTabData"
          v-if="goodsDetail"
        />
      </el-tab-pane>
      <!-- 系统映射表 -->
      <el-tab-pane :label="$t('goods.tab.mappingData')">
        <mapping-data
          ref="mappingData"
          :isEdit="true"
          :dataMapping="goodsDetail.systemMaps || []"
          :callLogsData="goodsDetail.callLogs || []"
          v-if="goodsDetail"
        />
      </el-tab-pane>
      <!-- 历史记录 -->
      <el-tab-pane :label="$t('goods.tab.historyData')">
        <history-data
          ref="historyData"
          :dataHistories="goodsDetail.dataHistories"
          v-if="goodsDetail"
        />
      </el-tab-pane>
    </el-tabs>
    <!-- 底部按钮 -->
    <!--<div class="fixed-bottom-btnList" v-if="goodsDetail">
      <el-button
        v-hasPermi="['2021050815443465317']"
        type="primary"
        v-if="userInfo.userInfo.adminFlag == '1'"
        :disabled="goodsDetail.parentProductStatus != 'ZT03'"
        @click="updateProductStatus(1)"
        >{{ this.$t('goods.button.forbid') }}</el-button
      >
      <el-button
        v-hasPermi="['2021050815445388226']"
        type="primary"
        v-if="userInfo.userInfo.adminFlag == '1' && isProductDetails == 0"
        :disabled="goodsDetail.parentProductStatus != 'ZT04'"
        @click="updateProductStatus(0)"
        >{{ this.$t('goods.button.solveForbidParent') }}</el-button
      >
       <el-button
        type="primary"
        :disabled="goodsDetail.parentProductStatus!='ZT05'&&disable"
        @click="abandon"
      >{{this.$t("goods.button.abandon")}}</el-button> 
    </div>-->
  </div>
</template>

<script>
  import { mapState } from 'vuex';
  import wchgData from './components/wchgData'; // 物产化工主数据
  import companyData from './components/companyData'; // 公司自有数据
  import mappingData from './components/mappingData'; // 系统映射表
  import historyData from './components/historyData'; // 历史记录表
  import API from '@/api/masterData/goods';
  import XEUtils from 'xe-utils';
  import loading from '@/common/js/load.js'; //loading
  import { getLocalStorage } from '@/common/js/util.js';
  export default {
    name: 'goodsDetail',
    components: {
      wchgData,
      companyData,
      mappingData,
      historyData,
    },
    computed: {
      ...mapState({
        userInfo: (state) => state.userInfo,
        stateDictList(state) {
          if (state.dict.dictList.length > 10) {
            this.dictList.unitOptions = state.dict.dictList.find(
              (it) => it.dictType == 'basic_unit'
            ).dictList;
            this.dictList.incomeCourseOptions = state.dict.dictList.find(
              (it) => it.dictType == 'income_course'
            ).dictList;
            this.dictList.costCourseOptions = state.dict.dictList.find(
              (it) => it.dictType == 'cost_course'
            ).dictList;
            // this.dictList.addedTaxRateOptions =  state.dict.dictList.find(it=>it.dictType=="value_added_tax_rate").dictList;
            this.$baseRequest.getTaxRate({}).then((result) => {
              this.dictList.addedTaxRateOptions = result;
            });
            this.$forceUpdate();
          }
        },
      }),
      fromFlag() {
        if (this.$route.query.from === 'todo') {
          return true;
        } else {
          return false;
        }
      },
      propsGoodsId() {
        // 获取路由参数 => 合作伙伴详情
        return this.$route.query.propsGoodsId;
      },
    },
    watch: {
      stateDictList(newV) {
        if (newV.length > 10) {
          this.dictList.unitOptions = newV.find((it) => it.dictType == 'basic_unit').dictList;
          this.dictList.incomeCourseOptions = newV.find(
            (it) => it.dictType == 'income_course'
          ).dictList;
          this.dictList.costCourseOptions = newV.find(
            (it) => it.dictType == 'cost_course'
          ).dictList;
          // this.dictList.addedTaxRateOptions =  newV.find(it=>it.dictType=="value_added_tax_rate").dictList;
          this.$forceUpdate();
        }
      },
    },
    created() {
      this.$baseRequest.getTaxRate({}).then((result) => {
        this.dictList.addedTaxRateOptions = result;
        this.getDetail();
      });
      //this.getCompanyInfo()//获取公司信息
    },
    data() {
      return {
        loading: false,
        isProductDetails: 0, //标记基本详情子类数据
        disable: false,
        goodsDetail: {},
        firstTabData: {
          dataAuthTableData: [],
          baseData: {},
        },
        extendList: [], //扩展公司信息 同时也是数据权限
        companyOptions: [], //公司下拉
        dictList: {
          unitOptions: [],
          groupCategoryOptions: [],
          incomeCourseOptions: [],
          costCourseOptions: [],
          addedTaxRateOptions: [],
        }, //所有数据字典结果
        isReject: false, //判断是否有驳回权限
        isApproval: false, //判断是否有审批权限
      };
    },
    mounted() {
      // console.log(this.userInfo)
      this.$nextTick(() => {
        this.getMenuButton();
      });
    },
    methods: {
      handleReject(val) {
        let params = {
          businessIds: [this.$route.query.propsGoodsId],
          approvaResult: val,
        };
        loading.startLoading();
        this.$axios.post(API.UPDATE_IS_REJECT, params).then((res) => {
          loading.endLoading();
          if (res.data.code === 0) {
            this.$message({
              showClose: true,
              message: res.data.msg,
              type: 'success',
            });
            this.$router.go(-1);
          } else {
            this.$alert(res.data.msg);
          }
        });
      },
      determineSubclassesRejected(val) {
        this.disable = val;
      },
      getDictSelect() {
        //通过数据字典获取成本科目下拉
        this.$axios
          .post(API.DATA_DICT, { dictType: 'cost_course', tenantCode: this.userInfo.tenantCode })
          .then((res) => {
            if (res.data.code === 0) {
              this.dictList.costCourseOptions = res.data.data;
            }
          });
        //通过数据字典获取收入科目下拉
        this.$axios
          .post(API.DATA_DICT, { dictType: 'income_course', tenantCode: this.userInfo.tenantCode })
          .then((res) => {
            if (res.data.code === 0) {
              this.dictList.incomeCourseOptions = res.data.data;
            }
          });
        //通过数据字典获取基本单位下拉
        this.$axios
          .post(API.DATA_DICT, { dictType: 'basic_unit', tenantCode: this.userInfo.tenantCode })
          .then((res) => {
            if (res.data.code === 0) {
              this.dictList.unitOptions = res.data.data;
            }
          });
        //获取集团产品下拉分类
        this.$axios
          .post(API.DATA_DICT, { dictType: 'group_category', tenantCode: this.userInfo.tenantCode })
          .then((res) => {
            if (res.data.code === 0) {
              this.dictList.groupCategoryOptions = res.data.data;
            }
          });
        //获取增值税率
        // this.$axios.post(API.DATA_DICT, { dictType: 'value_added_tax_rate', tenantCode: this.userInfo.tenantCode }).then(res => {
        //   if (res.data.code === 0) {
        //     this.dictList.addedTaxRateOptions = res.data.data;
        //   }
        // })
      },
      //获取数据权限表格数据
      getCompanyInfo() {
        //判断是否是新增
        if (this.$route.name == 'addGoods') {
          //新增
          let extendList = [];
          let obj = {
            extendCompanyCode: this.userInfo.companyCode,
            extendCompanyName: this.userInfo.companyName,
            list: [],
          };
          extendList.push(obj);
          this.extendList = extendList;
        } else {
          this.extendList = this.goodsDetail.extendList;
        }
      },

      // 获取商品主数据详情
      getDetail() {
        const params = {
          id: this.propsGoodsId,
          productDetailCode: this.$route.query.productDetailCode,
        };
        this.$axios
          .post(API.PRODUCT_DETAIL, params)
          .then((res) => {
            if (res.data.code === 0) {
              this.goodsDetail = res.data.data;
              if (this.goodsDetail.customs) {
                delete this.goodsDetail.customs.gmtCreate;
                delete this.goodsDetail.customs.companyCode;
              }
              this.firstTabData.baseData.basicUnit = this.goodsDetail.basicUnit;
              this.extendList = this.goodsDetail.extendList;
              if (this.$refs.mappingData) {
                this.$refs.mappingData.tableData = this.goodsDetail.systemMaps;
                this.$refs.mappingData.callLogsDatalist = this.goodsDetail.callLogs;
              }
              this.$nextTick(() => {
                this.$refs.wchgData.setChildChecked();
              });
              // this.goodsDetail.valueAddedTaxCode = this.dictList.addedTaxRateOptions.find(i => i.value == this.goodsDetail.valueAddedTaxCode).label
              // this.isProductDetails = res.data.data.productDetails.length;
              //this.$refs.companyData.reloadData(this.goodsDetail.extendList);
              //this.getCompanyInfo();
            } else {
              this.$message({ showClose: true, message: res.data.msg, type: 'error' });
            }
          })
          .then(() => {});
      },
      //点击进入修改页面
      modify: XEUtils.debounce(function () {
        let path = {
          fromPath: {
            path: '/masterData/goodsDetail',
            name: 'goodsDetail',
            meta: {
              keepAlive: true,
              title: this.$t('goods.title.goodsDetail'),
            },
          },
          toPath: {
            path: '/masterData/editGoods',
            name: 'editGoods',
            meta: {
              keepAlive: true,
              title: this.$t('goods.title.editGoods'),
            },
            query: {
              propsGoodsId: this.goodsDetail.id,
              productDetailCode: this.$route.query.productDetailCode,
            },
          },
        };
        this.$store.dispatch('tagsView/backTabView', path).then(() => {
          this.$nextTick(() => {
            this.$router.push(path.toPath);
          });
        });
      }),
      //禁用或者解除禁用 0启用 1禁用
      updateProductStatus(val) {
        if (val == 1) {
          //禁用 跳转到禁用页面
          let path = {
            fromPath: {
              path: '/masterData/goodsDetail',
              name: 'goodsDetail',
              meta: {
                keepAlive: true,
                title: this.$t('goods.title.goodsDetail'),
              },
            },
            toPath: {
              path: '/masterData/forbidenGoods',
              name: 'forbidenGoods',
              meta: {
                keepAlive: true,
                title: this.$t('goods.title.forbidenGoods'),
              },
              query: { propsGoodsId: this.goodsDetail.id },
            },
          };
          this.$store.dispatch('tagsView/backTabView', path).then(() => {
            this.$nextTick(() => {
              this.$router.push(path.toPath);
            });
          });
        } else {
          var params = {
            forbidFlag: val,
            parentProductNo: this.goodsDetail.parentProductNo,
          };
          var ids = [];
          ids.push({ id: this.goodsDetail.id, version: this.goodsDetail.version });
          params.ids = JSON.stringify(ids);
          this.$axios.post(API.PRODUCT_STATUS_UPDATE, params).then((res) => {
            if (res.data.code === 0) {
              this.$message({
                showClose: true,
                message: res.data.msg,
                type: 'success',
              });
              //跳转列表
              let path = {
                fromPath: {
                  path: '/masterData/goodsDetail',
                  name: 'goodsDetail',
                  meta: {
                    keepAlive: true,
                    title: this.$t('goods.title.goodsDetail'),
                  },
                },
                toPath: {
                  path: '/masterData/goods',
                  name: 'goods',
                  meta: {
                    keepAlive: false,
                    title: this.$t('goods.title.goods'),
                  },
                  query: {},
                },
              };
              this.$store.dispatch('tagsView/backTabView', path).then(() => {
                this.$nextTick(() => {
                  this.$router.push(path.toPath);
                });
              });
            } else if (res.data.code === 10000) {
              //强制禁用
              this.$repeatAlert(
                "<div><img src='/static/img/tips.png'/>" +
                  "<div class='repeatContent'>" +
                  res.data.msg +
                  '</div></div>',
                '',
                {
                  dangerouslyUseHTMLString: true,
                  confirmButtonText: this.$t('goods.message.forciblyDisable'),
                  center: true,
                  callback: (action) => {
                    if (action === 'confirm') {
                      params.forceFlag = 0;
                      this.$axios.post(API.PRODUCT_STATUS_UPDATE, params).then((res) => {
                        if (res.data.code === 0) {
                          this.getData();
                          this.$message({
                            showClose: true,
                            message: res.data.msg,
                            type: 'success',
                          });
                        } else {
                          this.$message({ showClose: true, type: 'error', message: res.data.msg });
                        }
                      });
                    }
                  },
                }
              );
            } else {
              this.$message({
                showClose: true,
                message: res.data.msg,
                type: 'error',
              });
            }
          });
        }
      },
      //放弃
      abandon() {
        const params = {
          id: this.goodsDetail.id,
          parentProductNo: this.goodsDetail.parentProductNo,
          version: this.goodsDetail.version,
        };
        this.$axios
          .post(API.CANCEL_MOD, params)
          .then((res) => {
            if (res.data.code === 0) {
              this.$message({
                showClose: true,
                message: res.data.msg,
                type: 'success',
              });
              this.returnPath();
            } else {
              this.$message({ showClose: true, message: res.data.msg, type: 'error' });
            }
          })
          .then(() => {});
      },
      //同步mdg
      syncMdg() {
        let value = 1;
        this.firstTabData = this.$refs.wchgData.exportChildData();
        // let taxRate = ''
        // let valueAddedTaxRateValue = {}
        // taxRate = this.firstTabData.baseData.valueAddedTaxRateName
        // valueAddedTaxRateValue = this.dictList.addedTaxRateOptions.find((i) => i.label == taxRate)
        // this.firstTabData.baseData.valueAddedTaxRate = valueAddedTaxRateValue.value
        this.extendList = this.$refs.companyData.exportChildData();
        const {
          parentProductNo,
          tenantCode,
          companyCode,
          departmentCode,
          departmentName,
          requestPerson,
          productChName,
          productSearchCode,
          productEnName,
          groupCategory,
          basicUnit,
          valueAddedTaxRate,
          customsId,
          salesTaxRate,
          salesTaxCode,
        } = this.firstTabData.baseData;
        let extendList = JSON.parse(JSON.stringify(this.extendList));
        extendList.map((item) => {
          item.list = JSON.stringify(item.list);
        });
        let permissions = [];
        this.firstTabData.dataAuthTableData.map((item) => {
          permissions.push({
            permissionCompanyCode: item.extendCompanyCode,
            permissionCompanyName: item.extendCompanyName,
            dataStatus: item.dataStatus,
            id: item.id,
          });
        });
        const params = {
          parentProductNo,
          tenantCode,
          companyCode,
          departmentCode,
          departmentName,
          requestPerson,
          productChName,
          productSearchCode,
          productEnName,
          groupCategory,
          basicUnit,
          valueAddedTaxRate,
          customsId,
          salesTaxRate,
          salesTaxCode,
          id: this.goodsDetail.id,
          version: this.goodsDetail.version,
          sendDetails: this.firstTabData.goodsTableData,
          extendList: JSON.stringify(extendList),
          permissions: JSON.stringify(permissions),
          ids: JSON.stringify(this.firstTabData.ids),
          operateFlag: value,
          adminFlag: this.userInfo.userInfo.adminFlag,
          companyName: this.goodsDetail.companyName,
        };
        this.loading = true;
        this.$axios.post(API.PRODUCT_SYNCMDG, params).then((res) => {
          this.loading = false;
          if (res.data.code === 0) {
            this.returnPath();
          } else {
            this.$alert(res.data.msg);
          }
        });
      },
      // 返回列表页
      returnPath() {
        let path = {
          fromPath: {
            path: '/masterData/goodsDetail',
            name: 'goodsDetail',
            meta: {
              keepAlive: true,
              title: this.$t('goods.title.goodsDetail'),
            },
          },
          toPath: {
            path: '/masterData/goods',
            name: 'goods',
            meta: {
              keepAlive: false,
              title: this.$t('goods.title.goods'),
            },
          },
        };
        this.$store.dispatch('tagsView/backTabView', path).then(() => {
          this.$nextTick(() => {
            this.$router.push(path.toPath);
          });
        });
      },
      // 获取菜单按钮
      async getMenuButton() {
        // console.log("diayong",JSON.parse(this.userInfo).account)
        const { data } = await this.$axios.post(
          '/maindata/role/getRoleMenuButton' +
            '?MENU_CODE=' +
            '2019121908520356248' +
            '&USER_NAME=' +
            getLocalStorage('userInfo').userInfo.account
        );

        if (data?.code == 0) {
          data?.data?.map((item) => {
            if (item.label == '驳回' || item.attributes.buttonUrl == 'reject') {
              this.isReject = true;
            }
            if (item.label == '批准' || item.attributes.buttonUrl == 'approval') {
              this.isApproval = true;
            }
          });
        }
      },
    },
  };
</script>

<style scoped>
  .goodsDetail {
    padding: 10px;
    background-color: #fff;
    margin-bottom: 80px;
  }
  /* 顶部按钮 */
  .goodsDetail .btn {
    text-align: left;
    padding: 20px 0px;
  }
  .goodsDetail .btns {
    text-align: right;
    padding: 20px 0px;
  }
</style>
